import OpportunityFeedback from './OpportunityFeedback.component';

export default OpportunityFeedback;